import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const FilterContainer = styled.div`
    background-color: #f5f5f5 ;
    display: flex;
    border-top-left-radius: ${(props) =>
        props.borderTopLeftRadiusStyle
            ? props.borderTopLeftRadiusStyle
            : '0px'};
    border-top-right-radius: ${(props) =>
        props.borderTopRightRadiusStyle
            ? props.borderTopRightRadiusStyle
            : '0px'};
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    color: #140f4b;
    justify-content: flex-start;
    width: ${(props) => (props.widthStyle ? props.widthStyle : '100%')};
    min-height: ${(props) =>
        props.minHeightStyle ? props.minHeightStyle : '40px'};
    height: auto;
    border-radius: ${(props) =>
        props.borderRadiusStyle ? props.borderRadiusStyle : '5px'};
    box-shadow: ${(props) =>
        props.boxShadowStyle ? props.boxShadowStyle : '0px 3px 6px 0 #f5f5f5 '};
    align-items: center;
    position: relative;

    & span {
        font-family: AvenirNextWorld Demi;
        margin-left: 5px;
        margin-right: 5px
    }

    ${media.mobileDevice`
        flex-direction: column;
        padding: 45px 6px 20px; //
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin: 0 0 -1px 0;
        box-shadow: none;
        min-height: auto;        
        align-items: flex-start;
        width: ${(props) => (props.mobileWidthStyle ? props.mobileWidthStyle : '100%')};
    `}
`;

export const ViewContainer = styled.div`
    margin: 0 10px;
    flex-basis: ${(props) => (props.flexBasis ? props.flexBasis : '10%')};
    display: flex;
    align-items: center;
    word-break: ${({ wordBreak }) => wordBreak && wordBreak};

    & span {
        font-family: AvenirNextWorld Demi;
        white-space: nowrap;
    }

    ${media.mediumDevice`
        flex-basis: ${(props) =>
            props.flexBasisStyle ? props.flexBasisStyle : '20%'};
    `}
`;

export const OrderContainer = styled.div`
    margin: 0 10px;
    display: flex;
    align-items: center;
    & span {
        font-family: AvenirNextWorld Demi;
        white-space: nowrap;
    }
    ${media.mobileDevice`
        margin-top: 15px;
    `}
`;

export const FilterDetailsContainer = styled.div`
    display: flex;
    margin: 0 5px 0 10px;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &::-webkit-scrollbar {
        display: none;
    }

    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation: portrait) {
        max-width: ${(props) => (props.ipadWidth ? props.ipadWidth : '100%')};
    }
    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation: landscape) {
        max-width: ${(props) =>
            props.ipadLandscapeWidth ? props.ipadLandscapeWidth : '100%'};
    }
    ${media.mobileDevice`
        margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')};
        width: 95%;
        max-width: 100%;
    `}
`;

export const ExtraContainer = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #1010eb;
    // border-left: 5px solid #ffff;
    // border-right: 5px solid #ffff;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    line-height: 25px;
    cursor: pointer;
    // background-color: #ffffff;
    &::-webkit-scrollbar {
        display: none;
    }
         margin-left:5px;
`;

export const FilterStringWithPipe = styled.p`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex: 1;
    margin: 0 0 0 5px;
    padding: 0;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    text-align: left;
    color: #140f4b;
     ${media.mobileDevice`
     flex:none;
    `}
`;


export const Counter = styled.div`
    height: 21px;
    font-family: 'AvenirNextWorld Regular';
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 11px;
    opacity: 1;
    align-items: center;
    text-align: center;
    padding: 0px 1px 2px 1px;
    width: fit-content;
    cursor: pointer;
    // margin-top: 2px;
    ${media.mobileDevice`
    border-radius: 11px;
    `}
`;
export const CounterNumber = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    letter-spacing: -1.1px;
    color: #1010eb;
    width: 26px;
    text-align: center;
    opacity: 1;
    ${media.mobileDevice`    
    `}
`;

export const ClearFilterDesktop = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    padding-top: 1px;
    color: #1010eb;
    display: block;
    text-align: right;
    margin-right: 5px;
    width: 120px;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    ${media.mobileDevice`
        text-align: left;
        // margin-left: ${(props) => (props.marginLeftTemplate ? '0rem' : '0px !important')};
        margin-bottom: ${(props) =>
            props.marginBottomTemplate ? props.marginBottomTemplate : ''};

    `}
`;

export const FilterWrapperContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: #f5f5f5;
`;

export const ClearFilterMobile = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    padding-top: 1px;
    color: #1010eb;
    display: block;
    text-align: right;
    margin-right: 5px;
    width:-webkit-fill-available;
    ${media.mobileDevice`
        text-align: left;
        margin-left: ${(props) => (props.marginLeftTemplate ? '0rem' : '10px !important')};
        margin-bottom: ${(props) =>
            props.marginBottomTemplate ? props.marginBottomTemplate : ''};

    `}
`;

